import { AnalyticsStore, ContextStore, ExperimentStore } from 'bernie-plugin-mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { MultiItemStore } from 'src/common/stores/multi-item-store';
import { SearchResultsStore } from 'src/common/stores/search-results-store';
import { UIPageStore } from 'src/common/stores/ui-page-store';

import { PaginationButtonsTrigger, PaginationNavigation } from './pagination-navigation-buttons';
import { ShowMoreButton, ShowMoreButtonTrigger } from './show-more-button';

interface PaginationProps {
  searchResults?: SearchResultsStore;
  context?: ContextStore;
  uiPage?: UIPageStore;
  analytics?: AnalyticsStore;
  multiItem?: MultiItemStore;
  experiment?: ExperimentStore;
}

const refreshAds = () => {
  if (document && CustomEvent && typeof document.dispatchEvent === 'function') {
    document.dispatchEvent(new CustomEvent('mesoTriggeredRefresh', { detail: { type: 'impressionRefresh' } }));
  }
};

export const Pagination = inject(
  'searchResults',
  'context',
  'uiPage',
  'analytics',
  'multiItem',
  'experiment'
)(
  observer(({ searchResults, context, uiPage, analytics, multiItem, experiment }: PaginationProps) => {
    const handleNext = React.useCallback(() => {
      if (searchResults?.pagination?.trigger?.__typename === 'LodgingPaginationNavigationButtons') window.scrollTo(0, 0);

      refreshAds();
      if (searchResults && analytics && context && multiItem && uiPage && experiment) {
        searchResults.showNextPage(analytics, context, multiItem, uiPage, experiment);
      }
    }, [analytics, context, experiment, multiItem, searchResults, uiPage]);

    const handlePrev = React.useCallback(() => {
      if (searchResults?.pagination?.trigger?.__typename === 'LodgingPaginationNavigationButtons') window.scrollTo(0, 0);

      refreshAds();
      if (searchResults && analytics && context && multiItem && uiPage && experiment) {
        searchResults.showPreviousPage(analytics, context, multiItem, uiPage, experiment);
      }
    }, [analytics, context, experiment, multiItem, searchResults, uiPage]);

    if (!searchResults?.pagination?.trigger) return null;

    const {
      pagination: {
        trigger: { __typename: type, ...trigger },
      },
      isLoading,
    } = searchResults;

    switch (type) {
      case 'LodgingPaginationNavigationButtons':
        return (
          <PaginationNavigation
            isLoading={isLoading}
            onNextPage={handleNext}
            onPrevPage={handlePrev}
            paginationLabel={searchResults.pagination.paginationLabel ?? ''}
            pagingNextButton={(trigger as PaginationButtonsTrigger)?.nextButton}
            pagingPrevButton={(trigger as PaginationButtonsTrigger)?.previousButton}
          />
        );
      case 'UIPrimaryButton':
        return searchResults.thereAreMoreListingsToFetch ? (
          <ShowMoreButton
            isLoading={isLoading}
            linkName="Show more results"
            rfrr={(trigger as ShowMoreButtonTrigger)?.action?.analytics?.referrerId ?? ''}
            onNextSubset={handleNext}
          />
        ) : null;
      default:
        return null;
    }
  })
);
